import {ErrorCatalogId} from "platformed-client/types";
import {platformedClient} from ".";

export async function listInCatalog(catalogId: ErrorCatalogId) {
  return await platformedClient.internalRequest(
    "get",
    "/region/{region}/api/reported_error_catalogs/{catalog_id}/errors",
    {path: {catalog_id: catalogId}},
  );
}
